<template>
  <div class="all">
    <Head ref="myTop" :StatusType="StatusType" :goodsname="shopName" @getEmit="getEmit"></Head>
<!--    {{time}}-->
    <div class="ListOfCommodities">
      <div class="ListOfCommodities_title">
        首页 > 商品搜索 > {{sousuoName}}
      </div>
      <div class="ListOfCommodities_cen">
        <el-row style="margin:10px 0;">
          <el-col :span="5" v-if="pid == 1">
            <div style="width: 90%;border: 1px solid #ff4500;">
              <div class="ListOfCommodities_cen_title">
                {{List.name}}
              </div>
              <div class="ListOfCommodities_cen_cen">
                <el-collapse v-model="activeNames" @change="handleChange">
                  <el-collapse-item v-for="(item,key) in List.two_class" :title="item.name" :name="key+1" :key="key">
                    <span v-for="(val,index) in item.three_class" class="Therr" @click="getThree(val.id)" :key="index">{{val.name}}</span>
                  </el-collapse-item>
                </el-collapse>
              </div>
            </div>
          </el-col>
          <el-col :span="pid==1?19:24">
            <div class="ListOfCommodities_for" v-if="pid !== 1">
              <el-row style="margin:10px 0;border-bottom: 1px solid #d1d1d1">
                <el-col :span="1">
                  <div class="IntegralExchange_tab_One">
                    类别:
                  </div>
                </el-col>
                <el-col :span="21">
                  <div class="IntegralExchange_tab_Two" :class="type==1?'avieHei':'avieMin'">
                    <span v-for="(i,key) in GoodsClass" @click="getOneClass(i.id)"
                          :style="GoodsClassId == i.id?'color: #ff4500;':''" :key="key">{{i.name}}</span>
                  </div>
                </el-col>
                <el-col :span="1">
                  <div class="IntegralExchange_tab_Three" @click="getType(type)">
                    {{type == 1?'更多':'收起'}}
                  </div>
                </el-col>
              </el-row>
            </div>
            <div class="ListOfCommodities_for">
              <el-row style="margin:10px 0;border-bottom: 1px solid #d1d1d1">
                <el-col :span="1">
                  <div class="IntegralExchange_tab_One">
                    品牌:
                  </div>
                </el-col>
                <el-col :span="21">
                  <div class="IntegralExchange_tab_Two" :class="type1==1?'avieHei':'avieMin'">
                    <span v-for="(i,goods) in goodsbrand" @click="getGoodsBrand(i.id)"
                          :style="GoodsBrand == i.id?'color: #ff4500;':''" :key="goods">{{i.name}}</span>
                  </div>
                </el-col>
                <el-col :span="1">
                  <div class="IntegralExchange_tab_Three" @click="getType1(type1)">
                    {{type1 == 1?'更多':'收起'}}
                  </div>
                </el-col>
              </el-row>
            </div>
            <div class="ListOfCommodities_for">
              <el-row style="margin:10px 0;border-bottom: 1px solid #d1d1d1">
                <el-col :span="1">
                  <div class="IntegralExchange_tab_One">
                    价格:
                  </div>
                </el-col>
                <el-col :span="21">
                  <div class="IntegralExchange_tab_Two">
                    <span v-for="(i,keyone) in PriceList" :class="PriceListtype == i.id?'PriceListtype':''"
                          @click="getPriceList(i.id,i.type1,i.type2)" :key="keyone">{{i.name}}</span>
                  </div>
                </el-col>
               <!-- <el-col :span="1">
                  <div class="IntegralExchange_tab_Three" @click="getType1(type1)">
                    {{type1 == 1?'更多':'收起'}}
                  </div>
                </el-col>-->
              </el-row>
            </div>
            <div class="ListOfCommodities_for">
              <el-row style="margin:10px 0;border-bottom: 1px solid #d1d1d1">
                <el-col :span="1">
                  <div class="IntegralExchange_tab_One">
                    排序:
                  </div>
                </el-col>
                <el-col :span="22">
                  <div class="IntegralExchange_tab_Two Paixu">
                    <span v-for="(i,pai) in Paixu" :class="Paixutype==i.type?'PaixuClick':''" @click="getPaixu(i.type)" :key="pai">{{i.name}}</span>
                  </div>
                </el-col>
                <el-col :span="1">
                  <!--  <div class="IntegralExchange_tab_Three" @click="getType1(type1)">
                      {{type1 == 1?'更多':'收起'}}
                    </div>-->
                </el-col>
              </el-row>
            </div>
            <!--              商品-->
            <div class="IntegralExchange_shop">
              <div class="focusoncommodities_bot_two">
                <div class="focusoncommodities_bot_onw_for" v-for="(shop,key) in goodsShop" :key="key" @click="$router.push({path:'/details',query:{id:shop.id}})">
                  <div class="focusoncommodities_bot_onw_for_img">
                    <img :src="$store.state.Url+shop.goods_img" alt="">
                  </div>
                  <div class="focusoncommodities_bot_onw_for_text">
                    <span>{{shop.name}}</span>
                  </div>
                  <div class="focusoncommodities_bot_onw_for_shop">
                    <div class="focusoncommodities_bot_onw_for_shop_left">
                      <span>￥{{shop.price}}</span>
                    </div>
                    <div class="focusoncommodities_bot_onw_for_shop_right" @click="getAddShopIng(shop.id)">
                      <span></span>
                      加入购物车
                    </div>
                    <div class="clear"></div>
                  </div>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
      <!--<div style="text-align: center;margin-top: 30px">
        <el-pagination
          background
          layout="prev, pager, next"
          :page-size="20"
          @current-change="handleCurrentChange"
          @prev-click="getShang"
          @next-click="getXia"
          :total="total">
        </el-pagination>
      </div>-->
    </div>
    <Pagetail></Pagetail>
  </div>
</template>

<script>
  import Pagetail from '../assembly/Pagetail'
  import Head from '../assembly/Head'
  import {getList, getShops, getbrand, getoneClass, getshopping} from "../api/List";

  export default {
    name: "ListOfCommodities",
    components: {
      Pagetail, Head
    },
    data() {
      return {
        type: 1,
        type1: 1,
        activeNames: ['1'],
        List: {
          two_class: []
        },
        pid: 1, //控制排版大小
        Paixutype: '',
        PriceListtype: '',
        start_price: '', //最小价格
        end_price: '', //最大价格
        Paixu: [
          {
            type: 1,
            name: '推荐度',
          },
          {
            type: 2,
            name: '价格升序',
          },
          {
            type: 3,
            name: '价格降序',
          },
        ],
        PriceList: [

          {
            id: 0,
            type1: '',
            type2: '',
            name: '全部',
          },
          {
            id: 1,
            type1: 0,
            type2: 10,
            name: '0-10',
          },
          {
            id: 2,
            type1: 10,
            type2: 20,
            name: '10-20',
          },
          {
            id: 3,
            type1: 20,
            type2: 30,
            name: '20-30',
          },
          {
            id: 4,
            type1: 30,
            type2: 40,
            name: '30-40',
          },
          {
            id: 5,
            type1: 40,
            type2: 50,
            name: '40-50',
          },
          {
            id: 6,
            type1: 50,
            type2: 60,
            name: '50-60',
          },
          {
            id: 7,
            type1: 60,
            type2: 100000,
            name: '60以上',
          },
        ],
        goodsShop: [],
        goodsbrand: [],
        GoodsBrand: '',
        GoodsClass: [],
        GoodsClassId: '',
        shopName: '',
        ThreeId: '',
        StatusType: false,
        sousuoName:'',
        total:1,
        per_page:20,
        current_page:1,
        time:this.$route.query.time
      }
    },
    mounted() {
      this.chushi()
    },
    watch:{
      $route(){
        this.chushi()
      }
    },
    methods: {
      getAddShopIng(id){
        getshopping({goods_id:id,num:1}).then(res=>{
          this.$router.push({path:'/ShoppingCart'})
        })
      },
      chushi(){
        this.sousuoName = this.$route.query.shop
        if (this.$route.query.id || this.$route.query.cat) {
          this.pid = 1
          this.GoodsClassId = this.$route.query.id
          this.ThreeId = this.$route.query.cat
          this.sousuoName = this.$route.query.shop
          this.init()
          this.$refs.myTop.ClassInit(this.$route.query.id);
          //  调动组件的获取关键字方法
          this.getShop()
        } else if (this.$route.query.name){
          this.pid = 2
          this.shopName = this.$route.query.name
          this.sousuoName = this.shopName
          setTimeout(()=>{
            this.$refs.myTop.initName();
          },100)
          this.getShop()
        }else {
          this.pid = 2
          this.getShop()
        }
        this.getmounted()
      },
      //分页
      getShang(val){
        //点击上一页
        this.current_page = val
        this.getShop()
      },
      getXia(val){
        //点击下一页
        console.log(val)
        this.current_page = val
        this.getShop()
      },
      handleCurrentChange(val) {
        //点击数字页面
        this.current_page = val
        this.getShop()
      },
      getEmit(e){
        this.shopName = e
        this.sousuoName = this.shopName
        this.getShop()
      },
      getShop() {
        //商品
        if(this.shopName){
          console.log(1)
          getShops({
            num:this.per_page,
            page:this.current_page,
            name:this.shopName,//模糊搜索
            type:this.Paixutype, //排序
            start_price:this.start_price, //最小价格
            end_price:this.end_price, //最大价格
            brand_id:this.GoodsBrand, //品牌ID
          }).then(res => {
            this.goodsShop = res.result
            this.total = res.count
          })
        }else if(this.ThreeId){
          getShops({
            num:this.per_page,
            page:this.current_page,
            name:this.shopName,//模糊搜索
            type:this.Paixutype, //排序
            start_price:this.start_price, //最小价格
            end_price:this.end_price, //最大价格
            brand_id:this.GoodsBrand, //品牌ID
            cat_id:this.ThreeId, //三级分类ID
          }).then(res => {
            this.goodsShop = res.result
            this.total = res.count
          })
        }else {
          getShops({
            num:this.per_page,
            page:this.current_page,
            name:this.shopName,//模糊搜索
            type:this.Paixutype, //排序
            start_price:this.start_price, //最小价格
            end_price:this.end_price, //最大价格
            brand_id:this.GoodsBrand, //品牌ID
            one_class_id:this.GoodsClassId, //er级三类ID
            cat_id:this.ThreeId, //三级分类ID
          }).then(res => {
            this.goodsShop = res.result
            this.total = res.count
          })
        }
      },
      //品牌
      getGoodsBrand(id) {
        this.GoodsBrand = id
        this.getShop()
      },
      //三级分类ID
      getThree(id) {
        this.ThreeId = id
        this.getShop()
      },
      //一级分类ID
      getOneClass(id) {
        this.GoodsClassId = id
        this.getShop()
      },
      getmounted() {
        //品牌
        getbrand({}).then(res => {
          this.goodsbrand = res.result
          var list = {id: '', name: "全部", sort_order: 50, url: null, is_show: 1,}
          this.goodsbrand.splice(0, 0, list)
        })
        //全部分类
        getoneClass().then(res => {
          this.GoodsClass = res.result
          var list = {
            id: '',
            name: "全部",
            parent_id: 0,
            sort: 6,
            is_show: 1,
            style: null,
            img: null,
            url: null,
            photo: null
          }
          this.GoodsClass.splice(0, 0, list)
        })
      },
      //价格
      getPriceList(id, type1, type2) {
        this.PriceListtype = id
        this.start_price = type1
        this.end_price = type2
        this.getShop()
      },
      //排序
      getPaixu(PaiId) {
        this.Paixutype = PaiId
        this.getShop()
      },
      init() {
        getList({id: this.$route.query.Yiji}).then(res => {
          this.List = res.result;
        });
      },
      handleChange(val) {
        // console.log(val);
      },
      getType(e) {
        if (e == 1) {
          this.type = 2
        } else {
          this.type = 1
        }
      },
      getType1(e) {
        if (e == 1) {
          this.type1 = 2
        } else {
          this.type1 = 1
        }
      },
    }
  }
</script>

<style scoped lang="less">
  @import "css/ListOfCommodities";
</style>
<style>
  .el-collapse-item__header {
    /*color: red!important;*/
  }
</style>



// WEBPACK FOOTER //
// src/components/ListOfCommodities.vue